import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../components'
const OrganizationHolidayFormHTML = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            name="date"
            label="Holiday Date"
            validate={[validations.required]}
            hideTimeSelect={true}
            component={renderers.renderDatePicker}
          />
          <Field
            name="description"
            label="Description"
            validate={[validations.required]}
            component={renderers.renderField}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
export const OrganizationHolidayForm = reduxForm({
  form: 'organization-holiday-form',
})(OrganizationHolidayFormHTML)
